"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createStyled = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _merge = _interopRequireDefault(require("lodash/merge"));
var _react = require("@stitches/react");
var _cssElements = require("./helpers/cssElements");
var _cssNormalize = require("./helpers/cssNormalize");
var _cssReset = require("./helpers/cssReset");
var _domElements = require("./helpers/domElements");
var _mapBreakpoints = require("./helpers/mapBreakpoints");
var _styledDynamic = require("./helpers/styledDynamic");
var _excluded = ["theme"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var baseStyles = (0, _merge["default"])(_cssReset.cssReset, _cssNormalize.cssNormalize, _cssElements.cssElements);
var createStyledRoot = function createStyledRoot() {
  var styledRoot;
  if (typeof __ABYSS_PARCEL_BUILD__ !== 'undefined') {
    if (typeof window !== 'undefined' && window.parcelRoot) {
      styledRoot = window.parcelRoot;
    }
  }
  return styledRoot;
};
var createStyled = function createStyled(options) {
  var stitchesTheme = options.theme,
    styledOptions = (0, _objectWithoutProperties2["default"])(options, _excluded);
  var _createStitches = (0, _react.createStitches)(_objectSpread(_objectSpread({}, styledOptions), {}, {
      root: createStyledRoot(),
      theme: stitchesTheme,
      prefix: 'abyss',
      media: (0, _mapBreakpoints.mapBreakpoints)(stitchesTheme.breakpoints),
      utils: {
        focusRing: function focusRing(color) {
          if (color === 'none') {
            return {
              boxShadow: 'none'
            };
          }
          var ringColor = color.indexOf('$') === 0 ? "$colors".concat(color) : color;
          return {
            outline: 'none',
            boxShadow: "#fff 0px 0px 0px 2px, ".concat(ringColor, " 0px 0px 2px 4px")
          };
        }
      }
    })),
    styledStatic = _createStitches.styled,
    globalCss = _createStitches.globalCss,
    css = _createStitches.css,
    theme = _createStitches.theme,
    tokenizeTheme = _createStitches.createTheme,
    keyframes = _createStitches.keyframes,
    getCssText = _createStitches.getCssText,
    config = _createStitches.config;
  var styled = function styled(component, stitchesCss) {
    var cssObj = stitchesCss || {};
    var staticCss = cssObj["static"] || cssObj;
    if (cssObj.dynamic) {
      var dynamicCss = (0, _styledDynamic.mergeDynamicCss)(component.dynamicCss, cssObj.dynamic);
      var cssComponent = css(component, staticCss);
      return (0, _styledDynamic.styledDynamic)(cssComponent, dynamicCss);
    }
    return styledStatic(component, staticCss);
  };
  _domElements.domElements.forEach(function (el) {
    styled[el] = function (values) {
      return styled(el, values);
    };
  });
  return {
    styled: styled,
    globalCss: globalCss,
    baseStyles: baseStyles,
    css: css,
    theme: theme,
    tokenizeTheme: tokenizeTheme,
    keyframes: keyframes,
    getCssText: getCssText,
    config: config
  };
};
exports.createStyled = createStyled;